window.freelancerVerifiedFormatter = function(value, row) {
    let html = '';
    html += value;
    if (row.freelancer_verified === 1) {
        html += '<i class="fas fa-check-circle fa-2xs text-success ms-1" title="'+__('Geverifieerd')+'"></i>';
    }
    return html;
}
